import React, { Component } from 'react'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { bookmarksMetadata, fetchAllEpisodeBookmarks } from '../../actions';
import EmptyState from '../../components/Common/EmptyState';
import EpisodeBookmarkCard from '../../components/Common/EpisodeBookmarkCard';
import { NextSeo } from 'next-seo';
import LoadingSpinner from '../../components/Common/Loading';
import AppAlertDiv from '../../components/Common/AppAlertDiv';
import { appleStoreUrl, playStoreUrl } from '../../lib/utils';
import HighlightsPage from '../../components/Common/highlightsPage';

export default class Bookmarks extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    render() {
        const { episodeBookmarks } = this.props;
        const { loading } = this.state;
        console.dir(episodeBookmarks);
        console.dir(bookmarksMetadata);
        // console.dir(this.episodesFn());
        if (loading) {
            return <LoadingSpinner />
        }
        return (
            <div>
                <NextSeo
                    title='Accelerated Web Player Bookmarks'
                    description='Find your bookmarked episodes here.'
                    noindex={true}
                    nofollow={true}
                // canonical='https://tedapp.ai/recently-played'
                // openGraph={{
                //     type: 'website',
                //     locale: 'en_IE',
                //     url: 'https://tedapp.ai/recently-played',
                //     site_name: 'Accelerated',
                // }}
                // twitter:{
                //     handle: '@handle',
                //     site: '@site',
                //     cardType: 'summary_large_image',
                // }
                />
                <h2>Highlights & Bookmarks</h2>
                <hr className='separator' />
                <br />
                <HighlightsPage />
                {/* <h3>Coming Soon.</h3>
                <AppAlertDiv isHtml={true}
                    message={`<p>Saved Highlights & Bookmarks are available on our mobile apps (<a href=${appleStoreUrl}
                            target='_blank' rel="noopener noreferrer">iOS</a> or <a href=${playStoreUrl}
                               target='_blank' rel="noopener noreferrer">Android</a>) for now and will be available on web soon.`} showIcon /> */}

                {/* {!loadingUserDetails && !userDetails &&
                    <EmptyState message="All your bookmarks will be here." imageName="recent-played" />
                } {
                    userDetails && episodeBookmarks && this.episodesFn().map((episodeBookmark) => (
                        <EpisodeBookmarkCard key={episodeBookmark.guid} guid={episodeBookmark.guid} episodeBookmark={episodeBookmarks[episodeBookmark.guid]} />
                    ))
                } */}
            </div>
        )
    }
}


Bookmarks.propTypes = {
    // loadingState: PropTypes.object,
    // loadingUserDetails: PropTypes.bool,
    // // fetchError: PropTypes.object,
    // userDetails: PropTypes.object,
    episodeBookmarks: PropTypes.any,
    // fetchAllEpisodeBookmarks: PropTypes.func,
    // getEpisodeReviews: PropTypes.func,
}

// const mapStateToProps = (state) => {
//     return {
//         userDetails: state.userDetails,
//         // loadingState: state.loadingState,
//         // fetchError: state.errorsState,
//         episodeBookmarks: state.episodeBookmarks,
//     }
// }

// const mapDispatchToProps = (dispatch) => {
//     return {
//         fetchAllEpisodeBookmarks: bindActionCreators(fetchAllEpisodeBookmarks, dispatch),
//     }
// };

// export default connect(mapStateToProps, mapDispatchToProps)(Bookmarks);
